
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqYFzZvtwKoF7kvwB9_9m9LnRxgBfi9U_IxD09Q_45qPnSMMeta } from "/codebuild/output/src3588588920/src/src/pages/faq.vue?macro=true";
import { default as menuBU6PyBZDWQnoqUhR6b2_Qj7xNdaPJxDL3_45iw_450evCdAMeta } from "/codebuild/output/src3588588920/src/src/pages/menu.vue?macro=true";
import { default as indexhPj_45bXtqwiq5mfTAmSaj4tX9A5vu7AYSyuyhRsfGAgkMeta } from "/codebuild/output/src3588588920/src/src/pages/index.vue?macro=true";
import { default as contact9ZWFO9_gwYB1Ry9gFSU7mMKDF_45LXP11pQJwsFMmzWKMMeta } from "/codebuild/output/src3588588920/src/src/pages/contact.vue?macro=true";
import { default as tutorialXn8lfVbZ_45Qa4W3AgcKV3QWV_bot_iEMiRf3g8v_45mHQ0Meta } from "/codebuild/output/src3588588920/src/src/pages/tutorial.vue?macro=true";
import { default as agreementervA4ItQoAE_fV4c0xKO1PgopRtCsAVOiFvv1NI0iwAMeta } from "/codebuild/output/src3588588920/src/src/pages/agreement.vue?macro=true";
import { default as about_45passscbmUL_45zka7cIDriD7_C32OJz8wgJgMjuHdAPNv3olQMeta } from "/codebuild/output/src3588588920/src/src/pages/about-pass.vue?macro=true";
import { default as indexJRoq98_KDIXnTxHRoE29abdR2BfV5_Zh_45aOhm1a_457woMeta } from "/codebuild/output/src3588588920/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93B46ubKaj74D_VLo4lSuMwvLr8Gjzjcgk8YgRagC2abIMeta } from "/codebuild/output/src3588588920/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceIKoWmOEyXdfwPpINRYYJyDpjj5PSc24_2_45tCKWvXFnoMeta } from "/codebuild/output/src3588588920/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93eFqbXGQ4rcHyzohhaIE_DymqoCpdyky57HQYIN6CP7EMeta } from "/codebuild/output/src3588588920/src/src/pages/notice/[id].vue?macro=true";
import { default as index1g7Hzm70jgsv5zyozjqYy7BGE6Gv_45TRYaiV_diL8Pv8Meta } from "/codebuild/output/src3588588920/src/src/pages/coupon/index.vue?macro=true";
import { default as indexoPXMrmuiJjo0GXeplYeUtC7B_45H66Ip5pLa1K06TdjhMMeta } from "/codebuild/output/src3588588920/src/src/pages/mypage/index.vue?macro=true";
import { default as index2tVAgWB1wUAITKJoT0hYIPhttuPBP7cB_gyP6tyJd7UMeta } from "/codebuild/output/src3588588920/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93WqMxcTqvJM2asSWIkJBvTKEnsfX2IOpkID4nPiVuyEwMeta } from "/codebuild/output/src3588588920/src/src/pages/parking/[id].vue?macro=true";
import { default as index1j08e2kfG2vzi9rOfXRsWX7X16ccHQfUaYILwBu4H5IMeta } from "/codebuild/output/src3588588920/src/src/pages/history/index.vue?macro=true";
import { default as index0QzB3UhBl5lWmK6E3yw_45F7_45UcxsbMEIRZxtznMuzlk8Meta } from "/codebuild/output/src3588588920/src/src/pages/monthly/index.vue?macro=true";
import { default as indexVdlJUOYu6RwlBSL95iJn_HRXROHX0XvSCT9mrfasAnMMeta } from "/codebuild/output/src3588588920/src/src/pages/sign-in/index.vue?macro=true";
import { default as index3OtONK5YXDIykjkbcCjr9MDhZGdv4sqkqgKXBM5My7YMeta } from "/codebuild/output/src3588588920/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviYgFEqErS10cY3TpijC2e4LOan0sB4Q1sf71HlVfL_TkMeta } from "/codebuild/output/src3588588920/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editGM0E2bljH7Moy2sW5Qn6jgeFuhn5d_45VVVGMDJixmOE0Meta } from "/codebuild/output/src3588588920/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementbrTVswQWcce_qKE5LIWznU1JVfZgie1yAAWhLXOAqQEMeta } from "/codebuild/output/src3588588920/src/src/pages/pass-agreement.vue?macro=true";
import { default as index95d6ahyOODB_45i4hRAJwtg_ZwXyffGBdiHhF_LRSJNnwMeta } from "/codebuild/output/src3588588920/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dJgn5Kxldy_45NiI1r1LWNh98e0cIOftESg6EcLIy2CCpgMeta } from "/codebuild/output/src3588588920/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmef2YBe9mqxln_45LTHIf0dzcs55fM80qm4A790vvGCl_45EMeta } from "/codebuild/output/src3588588920/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexG0HDVueSEenr8D4tQqq8_45C0vFLd20DUQWe_6hKdwggQMeta } from "/codebuild/output/src3588588920/src/src/pages/card/create/index.vue?macro=true";
import { default as indexMx9JOw3FY50GOV6bureUMQkXS_45oWzP7bJUc2gW1s5_45AMeta } from "/codebuild/output/src3588588920/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmNKMuxs_45AWcQg6Ej3WiexJW8Qbv_llmv0ZZbNDVLToncMeta } from "/codebuild/output/src3588588920/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmO2bv3Dd1hqpFvIghErPYfvSjVleqFbS_456mq0MrPUoSsMeta } from "/codebuild/output/src3588588920/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completej3Ty3FNDx1Kj6zeqEEX9gmDVzWg3wmeYGuNQYBDpAgIMeta } from "/codebuild/output/src3588588920/src/src/pages/membership/complete.vue?macro=true";
import { default as registerkiiKkZNijnD365okBRJ6bdwybP0mpiWGGMu7GExuQJcMeta } from "/codebuild/output/src3588588920/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93UhdZcoM9F2t2WEU6ZF7j9SRupYdUVCl6jhoYXp38_45gQMeta } from "/codebuild/output/src3588588920/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmHjufQHed_45_PUnzU6hX6SGOV7CRInnwmIdUVg7cASPwYMeta } from "/codebuild/output/src3588588920/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93b8FBF89NpXWxT_S_45zUu3gBiNbSz89G_45RZwtC8rJ2adgMeta } from "/codebuild/output/src3588588920/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as index35B600DHLPS_8T0ji2SMqVRtuzcXogzEpmY_CyVQw_MMeta } from "/codebuild/output/src3588588920/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeHeCUjgH8DIB7ySLcuC8_45eJZ8jk2ES3m4zaO14UxwFvMMeta } from "/codebuild/output/src3588588920/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45code7pD6k4lXXWNBQQlUi_45aI_45WPkT5dAzBufVc3CwBKyWowMeta } from "/codebuild/output/src3588588920/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as complete9mY0GTTTTaJgLE2N1oZ9gWNV7uH2M8IqJXmoSsuTp3EMeta } from "/codebuild/output/src3588588920/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerLoibDM5ZLOVLUqWaSMpCzlI7dbUF5yK_pj1JG_DtzMoMeta } from "/codebuild/output/src3588588920/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeogE5XNjsvnj2k2_0Vbqe58MxKx1G_qiyaGoE2_455HdNAMeta } from "/codebuild/output/src3588588920/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexOnFBF6ZUfCUYMbxIMoDYf2G7A2GPe11G6nXFoBCIUmwMeta } from "/codebuild/output/src3588588920/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmd9uXYqUctRaJrtsszUDCItvcd75HgxDdIRMQPApqVA8Meta } from "/codebuild/output/src3588588920/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as complete1pTUOtNrk1v3XSPXq69qxolqY23blGfcIg2ZgAfMHNMMeta } from "/codebuild/output/src3588588920/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexpctzzWjVoJKYtVja08EH1YeQtejlJtCTY76JBbSEBxgMeta } from "/codebuild/output/src3588588920/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93OT9StKQSOPRQVayuMAfxXduqyjx0a1bUx6bQ6hUJC5kMeta } from "/codebuild/output/src3588588920/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completep4m93q3Zx5IzyAeUr6vv0y9NhODQsWvgCBF0zm655iIMeta } from "/codebuild/output/src3588588920/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasHoUoMaLyMyYBOc88uVV4UFsClqMFYNBXwIGksIhJEbgMeta } from "/codebuild/output/src3588588920/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplenxggRFg9gzeWFDf4DA3RZrt_454O443NZHGxTxIWVs4HEMeta } from "/codebuild/output/src3588588920/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailiFxnm2OGoQbkvPg9mPiYty56hip78_45jhp_45QRU94oC3wMeta } from "/codebuild/output/src3588588920/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirm3_GqjJoPz0fZL19CNky6p7r6pDQrwf4N7RNgoVLu7zYMeta } from "/codebuild/output/src3588588920/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentfWz9uJjO2IBKYJbcY0mKjV5EXeK5cZ2wBp_dr0DvBxQMeta } from "/codebuild/output/src3588588920/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmKIkjCybrn_CfQ7LUGCfvADXKre_LICa894w4nsBDqBwMeta } from "/codebuild/output/src3588588920/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateSCrjNnPAznKUO5p67OGYgmhaJ9kM4iEwoihL2RztJ2gMeta } from "/codebuild/output/src3588588920/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeTNLp2o85Q9JPaDWuzfW8_5QE3ZGfV7tSSFBRgVQMvy0Meta } from "/codebuild/output/src3588588920/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codew8s_8byX_45MhhWkg3oqiVWYm4VIbTbp1NHXQlA_45q7jKIMeta } from "/codebuild/output/src3588588920/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordm8D1Vsz4st2KGJiEz4rJk_45bcm7dcXDqb6GTXbASzSHMMeta } from "/codebuild/output/src3588588920/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasBxAIj68gqlu_Mj6F7lJWU_45duHYHpTggaglk0VgR0ZsUMeta } from "/codebuild/output/src3588588920/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register1APlEkvtU_45Uyd7dKKWlFCeB7XrOh8qytpB4mYANeJnYMeta } from "/codebuild/output/src3588588920/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codegjGLSDFz_K7qwID1uon6xs_45TIyO2Wl7f_r6eSy3AaDYMeta } from "/codebuild/output/src3588588920/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexSwNWrcU3oQFaX4VE97HSpSeoxAX5mqadhXaAjOmmvskMeta } from "/codebuild/output/src3588588920/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexKhlws3NDOGPTQ2OXMiEYadAsLERX1HjnwvhbsGPtlVUMeta } from "/codebuild/output/src3588588920/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index4Uk_z38pm0FUZ38adbctmdJ8w72_99GAoDsVIxoaHjEMeta } from "/codebuild/output/src3588588920/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexEtAh5lLt2obyJRU3nxNkUwHkKkTPRXK2I1H84go19ZUMeta } from "/codebuild/output/src3588588920/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateiBmaUgIEmcaJi0U0CcViah4OAP0OKQaIfhyeKTy4tdUMeta } from "/codebuild/output/src3588588920/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeQRhRr5QotYj00EywFd7mDsM_2JSYztrs3zqYlDJFYAAMeta } from "/codebuild/output/src3588588920/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmGOxp4jU_45YnbaHOrHsjLW5bMz5HZXXoXTvpak9Y_45EXzsMeta } from "/codebuild/output/src3588588920/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexcT45oqO_45Xjtg28DqVUJj0mR2IFj7bOgyqmWaQzFlvgUMeta } from "/codebuild/output/src3588588920/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeiWoe3SnEY_45nOqO_45PwfyKEmAtzq5f_Uaq2TDyXIyPNMcMeta } from "/codebuild/output/src3588588920/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateCkf0KmYdXzg3fVll5p6gpUBKkmeMjhrgy6i3LsXW0l8Meta } from "/codebuild/output/src3588588920/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexmGuEzl2rmRgbMLiNMkEkH_45LyWKCUzPlgM5K4bQwNDPgMeta } from "/codebuild/output/src3588588920/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexbYuy293eUihdViAJHuHYitItRkX2Kh5ePvC5f1xWCbkMeta } from "/codebuild/output/src3588588920/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as complete4cxlGmsikOSvHq50ZPyKSD7MgjXm1djDLwXIOMuFX5UMeta } from "/codebuild/output/src3588588920/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as index4ghUL38QhQBCiM_45Y4nGOPTSSs_TIam1v6gmHPxiFxkMMeta } from "/codebuild/output/src3588588920/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeC_4537NUvKniT4GKNdpM7HtoHaFuwmDLwVou2_456Jjd9RQMeta } from "/codebuild/output/src3588588920/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indextt2U9UHGNB0OZB40tjx_juiHyRSGesLI_45gwoqA8culwMeta } from "/codebuild/output/src3588588920/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexga0eeL12RmHwnl1BR3OsnzqShf4HGJn16AqTCRKtlisMeta } from "/codebuild/output/src3588588920/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexhY9L6i79vGwSDzgubsd9cpFb6dpzICetOe4H43tjxr4Meta } from "/codebuild/output/src3588588920/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatesTGKFqTndgCfYvlc5pdpQrFbl_HYAtO6dlUxPT7V8oQMeta } from "/codebuild/output/src3588588920/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmi8Hv5F7KRZOAmjZ_45oDgwiBz7oVqN_45crq6D54yf0g8WcMeta } from "/codebuild/output/src3588588920/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuBU6PyBZDWQnoqUhR6b2_Qj7xNdaPJxDL3_45iw_450evCdAMeta || {},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexhPj_45bXtqwiq5mfTAmSaj4tX9A5vu7AYSyuyhRsfGAgkMeta || {},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(index1g7Hzm70jgsv5zyozjqYy7BGE6Gv_45TRYaiV_diL8Pv8Meta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3588588920/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index1j08e2kfG2vzi9rOfXRsWX7X16ccHQfUaYILwBu4H5IMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3588588920/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexVdlJUOYu6RwlBSL95iJn_HRXROHX0XvSCT9mrfasAnMMeta || {},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: index3OtONK5YXDIykjkbcCjr9MDhZGdv4sqkqgKXBM5My7YMeta || {},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexG0HDVueSEenr8D4tQqq8_45C0vFLd20DUQWe_6hKdwggQMeta || {},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmNKMuxs_45AWcQg6Ej3WiexJW8Qbv_llmv0ZZbNDVLToncMeta || {},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmO2bv3Dd1hqpFvIghErPYfvSjVleqFbS_456mq0MrPUoSsMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3588588920/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completej3Ty3FNDx1Kj6zeqEEX9gmDVzWg3wmeYGuNQYBDpAgIMeta || {},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerkiiKkZNijnD365okBRJ6bdwybP0mpiWGGMu7GExuQJcMeta || {},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmHjufQHed_45_PUnzU6hX6SGOV7CRInnwmIdUVg7cASPwYMeta || {},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeHeCUjgH8DIB7ySLcuC8_45eJZ8jk2ES3m4zaO14UxwFvMMeta || {},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45code7pD6k4lXXWNBQQlUi_45aI_45WPkT5dAzBufVc3CwBKyWowMeta || {},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: complete9mY0GTTTTaJgLE2N1oZ9gWNV7uH2M8IqJXmoSsuTp3EMeta || {},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerLoibDM5ZLOVLUqWaSMpCzlI7dbUF5yK_pj1JG_DtzMoMeta || {},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmd9uXYqUctRaJrtsszUDCItvcd75HgxDdIRMQPApqVA8Meta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3588588920/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: complete1pTUOtNrk1v3XSPXq69qxolqY23blGfcIg2ZgAfMHNMMeta || {},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexpctzzWjVoJKYtVja08EH1YeQtejlJtCTY76JBbSEBxgMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3588588920/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completep4m93q3Zx5IzyAeUr6vv0y9NhODQsWvgCBF0zm655iIMeta || {},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplenxggRFg9gzeWFDf4DA3RZrt_454O443NZHGxTxIWVs4HEMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3588588920/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailiFxnm2OGoQbkvPg9mPiYty56hip78_45jhp_45QRU94oC3wMeta || {},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirm3_GqjJoPz0fZL19CNky6p7r6pDQrwf4N7RNgoVLu7zYMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3588588920/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentfWz9uJjO2IBKYJbcY0mKjV5EXeK5cZ2wBp_dr0DvBxQMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3588588920/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmKIkjCybrn_CfQ7LUGCfvADXKre_LICa894w4nsBDqBwMeta || {},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeTNLp2o85Q9JPaDWuzfW8_5QE3ZGfV7tSSFBRgVQMvy0Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3588588920/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codew8s_8byX_45MhhWkg3oqiVWYm4VIbTbp1NHXQlA_45q7jKIMeta || {},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordm8D1Vsz4st2KGJiEz4rJk_45bcm7dcXDqb6GTXbASzSHMMeta || {},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register1APlEkvtU_45Uyd7dKKWlFCeB7XrOh8qytpB4mYANeJnYMeta || {},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codegjGLSDFz_K7qwID1uon6xs_45TIyO2Wl7f_r6eSy3AaDYMeta || {},
    component: () => import("/codebuild/output/src3588588920/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3588588920/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]